import React from "react";
import "./FlashITPremiumLogo.css";

const FlashITPremiumLogo = () => {
  return (
    <div className="premium-logo">
      <div className="icon">
        🛒
        <span className="bolt">⚡</span>
      </div>

      <h1 className="text">
        Flash<span>IT</span>
      </h1>

      <p className="tagline">Fast • Smart • Marketplace</p>
    </div>
  );
};

export default FlashITPremiumLogo;